import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

// Status-based dashboard interfaces matching backend DiscrepancyStatusDashboardDTO
export interface DailyStatusPoint {
  date: string;
  amount: number;
}

export interface CashStatusSection {
  pendingAmount: number;
  approvedAmount: number;
  rejectedAmount: number;
  totalAmount: number;
  pendingTimeline: DailyStatusPoint[];
  approvedTimeline: DailyStatusPoint[];
  rejectedTimeline: DailyStatusPoint[];
}

export interface StockStatusSection {
  pendingValue: number;
  approvedValue: number;
  rejectedValue: number;
  totalValue: number;
  pendingTimeline: DailyStatusPoint[];
  approvedTimeline: DailyStatusPoint[];
  rejectedTimeline: DailyStatusPoint[];
}

export interface CombinedTotals {
  pendingTotal: number;
  approvedTotal: number;
  rejectedTotal: number;
  grandTotal: number;
}

export interface DiscrepancyStatusDashboardDTO {
  period: { start: string; end: string; };
  cash: CashStatusSection;
  stock: StockStatusSection;
  combined: CombinedTotals;
}

// Product Discrepancy interface matching backend ProductDiscrepancyDTO
export interface ProductDiscrepancyDTO {
  productId: number;
  productName: string;
  discrepancyValue: number;
  negativeDiscrepancy: number;
  positiveDiscrepancy: number;
}

@Injectable({ providedIn: 'root' })
export class DiscrepancyReportService {
  private apiUrl = environment.apiUrl + '/discrepancies';

  constructor(private http: HttpClient) {}

  getStatusBasedReports(startDate: string, endDate: string): Observable<DiscrepancyStatusDashboardDTO> {
    const params = new HttpParams().set('startDate', startDate).set('endDate', endDate);
    return this.http.get<DiscrepancyStatusDashboardDTO>(this.apiUrl + '/dashboard', { params });
  }

  getTopProductsByDiscrepancyQuantity(startDate: string, endDate: string, limit: number = 10): Observable<ProductDiscrepancyDTO[]> {
    const params = new HttpParams()
      .set('startDate', startDate)
      .set('endDate', endDate)
      .set('limit', limit.toString());
    return this.http.get<ProductDiscrepancyDTO[]>(this.apiUrl + '/top-products-quantity', { params });
  }

  // Helper to format MAD currency
  formatCurrency(amount: number | undefined): string {
    const value = amount || 0;
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'MAD' }).format(value);
  }
}
